import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wizard-panels" }
const _hoisted_2 = { class: "wizard-panels__left d-flex flex-column" }
const _hoisted_3 = { class: "d-flex align-items-center fs-18 mb-4" }
const _hoisted_4 = { class: "mr-1" }
const _hoisted_5 = { class: "wizard-panels__right p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SceneStepItemsList = _resolveComponent("SceneStepItemsList")
  const _component_ScenePanelDeviceButtons = _resolveComponent("ScenePanelDeviceButtons")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_ScenePanelObjects = _resolveComponent("ScenePanelObjects")
  const _component_ScenePanelTime = _resolveComponent("ScenePanelTime")
  const _component_TabView = _resolveComponent("TabView")
  const _component_DialogAddTriggerAndCondition = _resolveComponent("DialogAddTriggerAndCondition")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("strong", _hoisted_4, _toDisplayString(_ctx.scene.triggers.length), 1),
          _createVNode("span", null, _toDisplayString(_ctx.triggerText), 1)
        ]),
        _createVNode(_component_SceneStepItemsList, {
          items: _ctx.scene.triggers,
          onEdit: _ctx.handleEdit,
          onRemove: _ctx.handleRemove,
          class: "flex-shrink-1"
        }, null, 8, ["items", "onEdit", "onRemove"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_TabView, { class: "p-tabview--custom" }, {
          default: _withCtx(() => [
            _createVNode(_component_TabPanel, {
              header: _ctx.$t('AppResource.Button')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ScenePanelDeviceButtons, {
                  currentDevices: _ctx.currentDevicesCommands,
                  assignableDevices: _ctx.compatibleDevices,
                  linkableObject: _ctx.scene,
                  addToastMessage: _ctx.$t('general.commandAdded'),
                  ruleServiceType: 
                            _ctx.SlotRuleServiceType.AUTOMATION_COMMAND
                        
                }, null, 8, ["currentDevices", "assignableDevices", "linkableObject", "addToastMessage", "ruleServiceType"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_TabPanel, {
              header: _ctx.$t('AppResource.ObjectCapitalized')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ScenePanelObjects, {
                  roomsWithObjects: _ctx.triggersRoomsList,
                  "step-to-add": _ctx.SceneWizardStepEnum.STEP_TRIGGER,
                  onAddTrigger: _ctx.handleAddTrigger
                }, null, 8, ["roomsWithObjects", "step-to-add", "onAddTrigger"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_TabPanel, {
              header: _ctx.$t('AppResource.DateAndTime')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ScenePanelTime, {
                  name: _ctx.$t('AppResource.DateAndTime'),
                  "step-to-add": _ctx.SceneWizardStepEnum.STEP_TRIGGER,
                  onAddTrigger: _ctx.handleAddTrigger
                }, null, 8, ["name", "step-to-add", "onAddTrigger"])
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_DialogAddTriggerAndCondition, {
      "is-visible": _ctx.isVisibleDialogTrigger,
      "onUpdate:is-visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isVisibleDialogTrigger = $event)),
      onConfirm: _ctx.handleDoEditTrigger,
      "step-to-add": _ctx.SceneWizardStepEnum.STEP_TRIGGER,
      triggerOrActionToAdd: _ctx.tempTriggerToEdit,
      triggerOrConditionType: 
            _ctx.tempTriggerDTOToEdit ? _ctx.tempTriggerDTOToEdit.sceneObjectType : null
        ,
      triggerOrConditionName: 
            _ctx.tempTriggerDTOToEdit ? _ctx.tempTriggerDTOToEdit.objectName : null
        
    }, null, 8, ["is-visible", "onConfirm", "step-to-add", "triggerOrActionToAdd", "triggerOrConditionType", "triggerOrConditionName"])
  ], 64))
}